import { Platform } from 'react-native'
import { useUser } from '@vatom/sdk/react'
import { Leva } from 'leva'
import { observer } from 'mobx-react-lite'

const partialEmails = [
  'jeff+',
  'luis.palacios+',
  'alistair+',
  'colin+',
  'yurki+',
  'ezequiel.benitez+'
]
const completeEmails = [
  'luis@pineapples.dev',
  'luis.palacios@vatom.com',
  'jeff@vatom.com',
  'jeff@vatominc.com',
  'alistair@vatominc.com',
  'colin@vatom.com',
  'colin@vatominc.com',
  'yurki@vatominc.com',
  'ezequiel.benitez@vatom.com'
]

const domains = ['vatom.com', 'vatominc.com']

const getShouldShowDebugPanel = (userEmail?: string) => {
  if (!userEmail) return false
  const emailParts = userEmail.split('@')
  const email = emailParts[0]
  const domain = emailParts[1]

  const shouldShowDebugPanel =
    completeEmails.includes(userEmail) ||
    (partialEmails.some(e => email.includes(e)) && domains.includes(domain))

  return shouldShowDebugPanel
}

export const DebugPanel = observer(() => {
  if (Platform.OS !== 'web') return null
  const user = useUser()
  const showPanel = __DEV__ || getShouldShowDebugPanel(user?.email)

  return (
    <Leva
      // theme={myTheme} // you can pass a custom theme (see the styling section)
      // fill // default = false,  true makes the pane fill the parent dom node it's rendered in
      // flat // default = false,  true removes border radius and shadow
      // oneLineLabels // default = false, alternative layout for labels, with labels and fields on separate rows
      // hideTitleBar // default = false, hides the GUI header
      collapsed // default = false, when true the GUI is collpased
      hidden={!showPanel} // default = false, when true the GUI is hidden
    />
  )
})
